import React from 'react';
import { ClipboardCheckIcon } from 'lucide-react';
import { DELIVERY_CITIES, IMAGES, QUOTE_CHECKLIST } from '../data/site';
export function TrustSection() {
  return <section className="bg-white py-10 sm:py-16" data-id="element-315" data-mp="rug7umv1850v">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-316" data-mp="wokibg3iav6p">
        <div data-id="element-317" data-mp="11lub95q3toza">
          <h2 className="font-display text-[1.75rem] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-318" data-mp="11ogjl7ktk8ik">
            Material real, en existencia, con gente que sí contesta
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-steel-600 sm:text-base" data-id="element-319" data-mp="8y6trzk4regv">
            En construcción el tiempo es dinero. Por eso cotizamos con datos claros y te confirmamos disponibilidad y
            fecha antes de que programes tu colado.
          </p>

          <div className="mt-5 rounded-xl bg-steel-50 p-4 sm:p-5" data-id="element-320" data-mp="1pb58id88x18o">
            <div className="flex items-center gap-2 text-navy-900" data-id="element-321" data-mp="1ub1bc957immn">
              <ClipboardCheckIcon className="h-5 w-5 text-accent-500" aria-hidden="true" data-id="element-322" data-mp="1ude0p7danz9q" />
              <h3 className="font-display text-lg font-semibold" data-id="element-323" data-mp="2pv25ytvecxhx">Para cotizarte bien, te pediremos:</h3>
            </div>
            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-324" data-mp="2gv5dsi9stgi4">
              {QUOTE_CHECKLIST.map((item, index) => <li key={item} className="flex items-center gap-2 text-sm text-navy-800" data-id="element-325" data-mp="2bwlrggram2p8" data-mpi={index}>
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy-800 text-[11px] font-semibold text-white" data-id="element-326" data-mp="26wpp0ly8ujbs">
                    {index + 1}
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <p className="mt-5 text-sm text-steel-600" data-id="element-327" data-mp="1t5uihgb7webd">
            <span className="font-semibold text-navy-900" data-id="element-328" data-mp="1t7fezbh3e7bv">Entregamos en:</span> {DELIVERY_CITIES.join(', ')} y zonas
            cercanas.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 lg:gap-4" data-id="element-329" data-mp="1j8g55pklc5na">
          <img src={IMAGES.almacen} alt="Colaborador de OA LOSAS frente al inventario de bovedilla EPS listo para entrega" className="col-span-2 aspect-[4/3] w-full rounded-xl object-cover object-[50%_35%] sm:aspect-[16/10]" loading="lazy" data-id="element-330" data-mp="19jspwbzi3xty" />
          <img src={IMAGES.entrega} alt="Bovedilla EPS de 300 cm cargada al hombro por una sola persona" className="hidden aspect-square w-full rounded-xl object-cover object-[50%_45%] sm:block" loading="lazy" data-id="element-331" data-mp="14kpvdlh5da08" />
          <img src={IMAGES.planos} alt="Equipo de OA LOSAS con casco frente a material en existencia" className="hidden aspect-square w-full rounded-xl object-cover object-[50%_40%] sm:block" loading="lazy" data-id="element-332" data-mp="1x8loyhbf6lss" />
        </div>
      </div>
    </section>;
}